import { parseAsEstreeExpression } from "./parse.js";
import { precook } from "./precook.js";
const ASTCache = new Map();
// `raw` should always be asserted by `isEvaluable`.
export function preevaluate(raw) {
  let {
    cache,
    ...restOptions
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const fixes = [];
  const source = raw.replace(/^\s*<%[~=]?\s|\s%>\s*$/g, m => {
    fixes.push(m);
    return "";
  });
  let expression = cache ? ASTCache.get(source) : undefined;
  if (!expression) {
    expression = parseAsEstreeExpression(source);
    if (cache) {
      ASTCache.set(source, expression);
    }
  }
  const attemptToVisitGlobals = precook(expression, {
    ...restOptions,
    expressionOnly: true
  });
  return {
    expression,
    attemptToVisitGlobals,
    source,
    prefix: fixes[0],
    suffix: fixes[1]
  };
}
export function isEvaluable(raw) {
  return /^\s*<%[~=]?\s/.test(raw) && /\s%>\s*$/.test(raw);
}
export function shouldAllowRecursiveEvaluations(raw) {
  return /^\s*<%~\s/.test(raw);
}
export function isTrackAll(raw) {
  return /^\s*<%=\s/.test(raw) && /\s%>\s*$/.test(raw);
}
export function clearExpressionASTCache() {
  ASTCache.clear();
}
//# sourceMappingURL=preevaluate.js.map